import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "us.style/antd.less";
import "us.style/index.scss";
import { Loader } from "us.common/components";

import App from "App";
import * as serviceWorker from "serviceWorker";
import store from "store";
import * as Azure from "us.helper/azure";
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { setupTitle } from "us.helper";
import { MsalProvider } from "@azure/msal-react";
import "us.helper/utility/dayjsConfig";

window.APP_MODULE = "admin";

export const msalInstance = new PublicClientApplication(Azure.msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
    msalInstance.setActiveAccount(null);
    window.location.reload(); // Optional: force UI update
  } else if (event.eventType === EventType.ACCOUNT_ADDED && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  } else if (event.eventType === EventType.ACCOUNT_REMOVED) {
    msalInstance.setActiveAccount(null);
    window.location.reload(); // Optional: force UI update
  }
});

//set the dynamic title
setupTitle();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </MsalProvider>
  </Provider>
);

// ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
